import { ChangeTracked, Community, Contact, LotStatusDescription } from "../types";

export class Lot {
    lotId: number;
    id: number;
    communityId: number;
    communityNumber: string;
    lotBlock: string;
    lotStatusDescription: LotStatusDescription;
    jobId: number;
    streetAddress1: string;
    streetAddress2: string;
    constructionBuildingNumber: string;
    constructionPhaseNumber: string;
    constructionStage: string;
    isMasterUnit: boolean;
    community: Community;
    contactNames: string;
    displayText: string;
    contacts?: Contact[] & ChangeTracked<Contact[]>;
    closeOfEscrow: Date;
    scarFinalDate: Date;
}
